/* ========================================================================
 * Bestdealdepot: FormValidator.js v1.0.0
 * Author: Jack yin
 * ======================================================================== */
+function ($, window, document) {
  'use strict';
  
  //global scope
  var scope;

  //custructor
  var FormValidator = function (element, options) {
	  this.options        = options;
	  this.$body          = $(document.body);
	  this.$element       = $(element);
	  this.$fields		= null;
	
	  this.init();
  };
  

  //static
  FormValidator.VERSION  = '1.0.0'
  FormValidator.DEFAULTS = {
	  selectorField: 'input[data-validate]',
	  errorHelpSelector: '.error-help'
  }
  
  //public
  FormValidator.prototype.init = function() {
	  scope = this;
	  
	  this.initFields();
  };
  
  FormValidator.prototype.initFields = function() {
	  this.$fields = this.$element.find(this.options.selectorField);
	  
	  this.$element.on('change', this.options.selectorField, function() {
		  var field = $(this);
		  
		  if (scope.singleValidate(field)) {
			  field.removeClass('invalid');
			  field.nextAll(scope.options.errorHelpSelector).hide();
		  }
	  });
  };
  
  FormValidator.prototype.isValid = function() {
	  if ( ! scope.checkFields()) {
		  return false;
	  }
	  
	  return true;
  };
  
  FormValidator.prototype.checkFields = function(fields) {
	  var valid = true;
	  
	  if (fields) {
		  if ( ! this.validate(fields)) {
			  valid = false;
		  }
	  }else {
		  if ( ! this.validate(this.$fields)) {
			  valid = false;
		  }
	  }
	  
	  return valid;
  };
  
  FormValidator.prototype.validate = function(fields) {
	  var valid = true;
	  
	  fields.each(function() {
		  var field = $(this);
		  
		  if (! scope.singleValidate(field)) {
			  valid = false;
		  }
	  });
	  
	  return valid;
  };
  
  FormValidator.prototype.singleValidate = function(field) {
	  if ( !field.attr('disabled')) {
		  //check reqruired field
		  if (field.data('validate') == 'required') {
			  if ( ! scope.checkRequired(field)) {
				  return false;
			  }
		  }
		  
		  //check length field
		  if (field.data('validate') == 'length') {
			  if ( ! scope.checkLength(field)) {
				  return false;
			  }
		  }
	  }
	  
	  return true;
  }
  
  FormValidator.prototype.checkLength = function(field) {
	  var minLength = field.data('minlength'),
	  	  maxLength = field.data('maxlength'),
	  	  value = field.val();
	  
	  //check min length
	  if (minLength) {
		  if (value.length < minLength) {
			  field.addClass('invalid');
			  
			  field.nextAll(this.options.errorHelpSelector).show();
			  
			  return false;
		  }
	  }
	  
	  //check max length
	  if (maxLength) {
		  if (value.length > maxLength) {
			  field.addClass('invalid');
			  
			  field.nextAll(this.options.errorHelpSelector).show();
			  
			  return false;
		  }
	  }
	  
	  return true;
  };
  
  FormValidator.prototype.checkRequired = function(field) {
	  if (! field.val()) {
		  field.addClass('invalid');
		  
		  field.nextAll(this.options.errorHelpSelector).show();
		  
		  return false;
	  }
	  
	  return true;
  };

  //PLUGIN DEFINITION
  function Plugin(option) {
	  return this.each(function () {
	      var $this   = $(this);
	      var data    = $this.data('sn.formvalidator');
	      var options = $.extend({}, FormValidator.DEFAULTS, $this.data(), typeof option == 'object' && option);
	
	      if ( ! data) {
	    	  $this.data('sn.formvalidator', (data = new FormValidator(this, options)));  
	      } 
	      
	      if (typeof option == 'string') {
	    	  data[option]();  
	      }	
	  });
  }

  // clear conflict
  var old = $.fn.formValidator;

  $.fn.formValidator             = Plugin;
  $.fn.formValidator.Constructor = FormValidator;

  $.fn.formValidator.noConflict = function () {
	  $.fn.formValidation = old;
	  
	  return this;
  }

  // FormValidator DATA-API
  $('form[data-toggle="formvalidator"]').each(function () {
	  var $form = $(this);
	  
	  Plugin.call($form, $form.data())
  });
}(jQuery, window, document);
